import { ICalculatorState, TBenefitProgram } from '../../types';

export interface ITrackUserInput {
  objectCost: number;
  downPayment: number;
  loanTermYears: number;
  programType: TBenefitProgram | null;
}

/* hasLifeInsurance из разметки аналитики не отправляем: такого поля в мини-калькуляторе нет */
export const getUserInput = (formState: ICalculatorState['initialFormState']): ITrackUserInput => ({
  objectCost: formState.objectCost,
  downPayment: formState.downPayment,
  loanTermYears: formState.loanTermYears,
  programType: formState.benefitProgram ?? null,
});
